"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = advancedContentHelper;

function advancedContentHelper(sliceData, linkedContent) {
  return linkedContent && sliceData.primary && sliceData.primary.advanced_content && linkedContent.find(function (linkedItem) {
    return linkedItem.id === sliceData.primary.advanced_content.id;
  });
}